<h2 mat-dialog-title>Add New User</h2>

<mat-dialog-content>
  <form [formGroup]="addUserForm">
    <!-- User Name Field -->
    <mat-form-field appearance="fill" class="full-width">
      <input matInput placeholder="Enter user name" formControlName="name" required>
      <mat-error *ngIf="addUserForm.get('name')?.hasError('required')">
        Name is required
      </mat-error>
      <mat-error *ngIf="addUserForm.get('name')?.hasError('whitespace')">
        Name cannot contain only whitespace
      </mat-error>
    </mat-form-field>

    <!-- User Email Field -->
    <mat-form-field appearance="fill" class="full-width">
      <input matInput type="email" placeholder="Enter email" formControlName="email" required>
      <mat-error *ngIf="addUserForm.get('email')?.hasError('required')">
        Email is required
      </mat-error>
      <mat-error *ngIf="addUserForm.get('email')?.hasError('customEmail')">
        Please enter a valid email
      </mat-error>
    </mat-form-field>

    <!-- User Role Field -->
    <mat-form-field appearance="fill" class="full-width">
      <mat-select formControlName="role" placeholder="Select role" required>
        <mat-option *ngFor="let role of roles" [value]="role">{{ role }}</mat-option>
      </mat-select>
      <mat-error *ngIf="addUserForm.get('role')?.hasError('required')">
        Role is required
      </mat-error>
    </mat-form-field>

    <!-- Companies Field -->
    <mat-form-field appearance="fill">
      <mat-select formControlName="companies" multiple  placeholder="Select companies" required>
        <mat-select-trigger>
          {{ addUserForm.get('companies')?.value?.[0] || 'Select companies' }}
          <span *ngIf="(addUserForm.get('companies')?.value?.length || 0) > 1">
            (+{{ (addUserForm.get('companies')?.value?.length || 0) - 1 }} other{{
            (addUserForm.get('companies')?.value?.length === 2 ? '' : 's') }})
          </span>
        </mat-select-trigger>
        <mat-option *ngFor="let company of companiesList" [value]="company">
          {{ company }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="addUserForm.get('companies')?.invalid">
        Select at least one company
      </mat-error>
    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="primary" (click)="onSave()" [disabled]="addUserForm.invalid || isSaving">
    <ng-container *ngIf="isSaving; else saveText">
      <mat-spinner diameter="20"></mat-spinner>
    </ng-container>
    <ng-template #saveText>Save</ng-template>
  </button>
</mat-dialog-actions>
